/* eslint-disable curly, react/forbid-prop-types, react/jsx-no-bind, object-property-newline, no-empty-function */
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { CalendarIcon, ClockIcon, DesktopComputerIcon, LocationMarkerIcon, TrashIcon } from "@heroicons/react/outline";
import { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

import MetaItem from "../MetaItem";
import { getTimezone } from "../../helpers/dates";
import { isRemoteEvent } from "../../helpers/event";
import { useCourseRegistration } from "../../services/CourseRegistrationProvider";

const CourseListItem = ({
	checked,
	course,
	selectable,
	setNewCoursesToRegister,
	showRemoveButton
}) => {
	const { registeredCourses, removeCourse } = useCourseRegistration();

	const handleRemove = useCallback(() => {
		removeCourse(course);
	}, [course.id]);
	const canRemove = useMemo(() => registeredCourses.filter(({ id }) => id === course.id).length > 0, [registeredCourses]);

	return (
		<div className="border w-100 mb-3">
			<Row className="justify-content-between py-3 w-100 ms-auto me-auto">
				{selectable ? (
					<Col className="d-flex align-items-center" lg={3} xs="auto">
						<Form.Group controlId="formBasicCheckbox">
							<Form.Check
								checked={checked}
								onChange={() => setNewCoursesToRegister((prevCourses) => {
									const courseAlreadyIncludes = prevCourses.filter((item) => item.id === course.id).length > 0;
									if (courseAlreadyIncludes) return prevCourses.filter((item) => item.id !== course.id);
									return [...prevCourses, course];
								})}
								type="checkbox"
							/>
						</Form.Group>
					</Col>) : null}

				<Col className="d-flex align-items-center" lg={3}>
					{course.title}
				</Col>

				{course.start ? (
					<Col className="d-flex" lg={3}>
						<MetaItem Icon={CalendarIcon} label={format(utcToZonedTime(course.start, getTimezone()), "MMMM dd, yyyy")} />
					</Col>) : null}

				{course.start ? (
					<Col className="d-flex" lg={3} xs="auto">
						<MetaItem Icon={ClockIcon} label={`${format(utcToZonedTime(course.start, getTimezone()), "h:mm b")} - ${format(utcToZonedTime(course.end, getTimezone()), "h:mm b")} EST`} />
					</Col>) : null}

				<Col className="d-flex" lg={3}>
					{isRemoteEvent(course)
						? <MetaItem Icon={DesktopComputerIcon} label="Online" />
						: (
							<MetaItem
								Icon={LocationMarkerIcon}
								label={typeof course.location === "string" ? course.location : course.location?.name}
							/>
						)}
				</Col>

				{ showRemoveButton && canRemove ? (
					<Col className="d-flex align-items-center" lg={3} xs="auto">
						<Button
							onClick={handleRemove}
							size="sm"
							variant="danger"
						>
							<TrashIcon className="i" />
						</Button>
					</Col>) : null}
			</Row>
			{course.error ? (
				<Alert className="mx-3" variant="danger">
					{course.error}
				</Alert>
			) : null}
		</div>
	);
};

CourseListItem.propTypes = {
	checked: PropTypes.bool,
	course: PropTypes.any.isRequired,
	selectable: PropTypes.bool,
	setNewCoursesToRegister: PropTypes.func,
	showRemoveButton: PropTypes.bool
};

CourseListItem.defaultProps = {
	checked: false,
	selectable: true,
	setNewCoursesToRegister: () => {},
	showRemoveButton: true
};

export default CourseListItem;
